export const dateFilter = (date: string): string => {
  // Cross Browsing
  const original = new Date(date.replace(/\s+/g, 'T')),
    year = original.getFullYear(),
    month = original.getMonth() + 1,
    day = original.getDate();

  return `${year}년 ${month}월 ${day}일`;
};
